module.exports = __webpack_public_path__ + "static/media/ricardo_monteiro.d8a06755.jpg";